@import 'mixins';
@import 'vars';

.toast-alert {
  display: flex;
  align-items: center;
  cursor: default;

  &--softphone {
    > svg {
      font-size: $font-size-normal;
    }
  }

  &__text {
    display: flex;
    flex-direction: column;
    margin-left: 10px;

    &__title {
      font-size: $font-size-normal;
      margin-bottom: 3px;

      &--softphone {
        font-size: $font-size-extra-small;
      }
    }

    &__message {
      font-size: $font-size-extra-small;
      line-height: $line-height-small;
    }
  }
}
